import clientAxios from "../../client";
import type { QueryType } from "@/common/types/common";
import type { SlugType, SlugPayloadType } from "@/common/types/slug";
import { formatQueryString } from "@/common/utils/common";

export async function slugList(owner_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/game/${owner_id}/slug/list${queryString}`,
  );
}

export async function slugGet(slug_id: string) {
  return await clientAxios.get(`admin/game/slug/${slug_id}/show`);
}

export async function slugCreate(owner_id: string, payload: SlugPayloadType) {
  return await clientAxios.post(`admin/game/${owner_id}/slug/create`, payload);
}

export async function slugPatch(slug_id: string, payload: Partial<SlugType>) {
  return await clientAxios.patch(`admin/game/slug/${slug_id}/patch`, {
    payload,
  });
}

export async function slugDel(slug_id: string) {
  return await clientAxios.del(`admin/game/slug/${slug_id}/delete`);
}
